import { jsx as _jsx } from "react/jsx-runtime";
import Modal from 'react-modal';
import { modalStyle } from './StyleModal';
Modal.setAppElement('#root');
export const ModalWindow = ({ children, modalOptions, style }) => {
    return (_jsx(Modal, Object.assign({ isOpen: modalOptions.isOpen, onRequestClose: modalOptions.onClose, style: modalStyle({ content: style === null || style === void 0 ? void 0 : style.content, overlay: style === null || style === void 0 ? void 0 : style.overlay }), contentLabel: "Modal window with context" }, { children: children })));
};
